import { ClassNames } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { LockOpen } from "@livechat/design-system-icons";
import {
  Button,
  Heading,
  Icon,
  Modal,
  ModalHeader,
  ModalPortal,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { trackEngagement } from "helpers/analytics";
import { getNextPlanHash } from "helpers/subscription-plans";
import { selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { SubscriptionViewActions, selectUpsellModalOpened, selectUpsellModalSource } from "store/views/subscription";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

import { SubscriptionRoutes } from "./constants";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const UpsellModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const source = useSelector(selectUpsellModalSource);
  const showUpsellModal = useSelector(selectUpsellModalOpened);
  const currentPlan = useSelector(selectCurrentSubscriptionPlan);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCloseUpsellModal = () => {
    dispatch(SubscriptionViewActions.closeUpsellModal());
    trackEngagement("Plan limit exceeded: upsell modal closed", undefined, { source });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleUpgradePlan = () => {
    history.push(`${SubscriptionRoutes.Plans}/${getNextPlanHash(currentPlan)}`);
    dispatch(SubscriptionViewActions.closeUpsellModal());
    trackEngagement("Plan limit exceeded: upsell modal CTA clicked", undefined, { source });
  };

  if (!showUpsellModal) {
    return null;
  }

  return (
    <ClassNames>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {({ css }: any) => (
        <ModalPortal zIndex={StackingContextLevel.Modal}>
          <Modal
            onClose={handleCloseUpsellModal}
            heading={<ModalHeader />}
            footer={
              <Flex width="100%" justifyContent="center" marginBottom={withVar(SpacingToken.Spacing10)}>
                <Button kind="primary" size="large" onClick={handleUpgradePlan}>
                  Upgrade plan
                </Button>
              </Flex>
            }
            contentClassName={css`
              max-width: 352px;
              width: 100%;
              margin: 0 ${withVar(SpacingToken.Spacing9)} ${withVar(SpacingToken.Spacing5)};
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: ${withVar(SpacingToken.Spacing3)};
            `}
          >
            <Icon source={LockOpen} size="xxxlarge" css={{ marginBottom: withVar(SpacingToken.Spacing1) }} />
            <Heading bold={false} size="lg">
              Plan limit reached
            </Heading>
            <Text textAlign="center">
              Upgrade now for full feature capabilities and even better ticket resolution experience.
            </Text>
          </Modal>
        </ModalPortal>
      )}
    </ClassNames>
  );
};

export { UpsellModal };
